<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.25 6.75C8.25 5.92157 7.57843 5.25 6.75 5.25C5.92157 5.25 5.25 5.92157 5.25 6.75C5.25 7.57843 5.92157 8.25 6.75 8.25C7.57843 8.25 8.25 7.57843 8.25 6.75ZM8.25 9.75V18.75H5.25V9.75H8.25ZM18.75 18.75H15.75V13.6875C15.75 12.8925 14.8575 12.2325 14.0625 12.2325C13.2675 12.2325 12.75 12.8925 12.75 13.6875V18.75H9.75V9.75H12.75V11.25C13.245 10.4475 14.52 9.93 15.375 9.93C17.25 9.93 18.75 11.46 18.75 13.3125V18.75Z"
        />
    </svg>
</template>
